import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { vacanciesService, ParsedVacancy } from '@/services';
import { Providers, State } from './types';
import { FETCH_ITEM, SET_NOTHING_FOUND, SET_VACANCY } from './consts';

const storeModule = ({ $api }: Providers) => {
  @Module({
    namespaced: true,
    stateFactory: true,
  })
  class VacancyStore extends VuexModule<State, any> {
    nothingFound: boolean = false;
    vacancy: ParsedVacancy | null = null;

    @Mutation
    [SET_VACANCY](data: ParsedVacancy) {
      this.vacancy = data;
    }

    @Mutation
    [SET_NOTHING_FOUND](payload: boolean) {
      this.nothingFound = payload;
    }

    @Action
    async [FETCH_ITEM](id: string) {
      const { commit } = this.context;

      if (!id) return;

      try {
        const { data } = await vacanciesService($api).getVacancy(id);
        commit(SET_VACANCY, data);
      } catch (err) {
        const error: any = err;
        if (error.response && error.response.status === 404) {
          commit(SET_NOTHING_FOUND, true);
        }
        commit(SET_VACANCY, []);
      }
    }
  }

  return VacancyStore;
};

export default storeModule;



// WEBPACK FOOTER //
// ./src/pages/vacancies/card/store.ts